/* import __COLOCATED_TEMPLATE__ from './generated-plan.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
import Component from '@glimmer/component';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type GeneratedPlanRenderable from 'embercom/objects/inbox/renderable/generated-plan';

export interface GeneratedPlanSignature {
  Args: {
    part: RenderablePart & { renderableData: GeneratedPlanRenderable };
  };
}

export default class GeneratedPlan extends Component<GeneratedPlanSignature> {
  get planData() {
    return this.args.part.renderableData.planData;
  }

  get phases() {
    return this.planData?.phases ?? [];
  }

  get updatedAt(): Date | null {
    let raw = this.planData?.updated_at;
    return raw ? new Date(raw) : null;
  }

  get total(): number {
    return this.phases.reduce((sum, p) => sum + p.tasks.length, 0);
  }

  get done(): number {
    return this.phases.reduce((sum, p) => sum + p.tasks.filter((t) => t.done).length, 0);
  }

  get progressSegments(): boolean[] {
    return this.phases.flatMap((p) => p.tasks.map((t) => t.done));
  }

  get numberedPhases(): {
    name: string;
    tasks: { id: string; title: string; done: boolean; stepNumber: number }[];
  }[] {
    let step = 0;
    return this.phases.map((phase) => ({
      name: phase.name,
      tasks: phase.tasks.map((t) => {
        step++;
        return { id: t.id, title: t.title, done: t.done, stepNumber: step };
      }),
    }));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::GeneratedPlan': typeof GeneratedPlan;
    'inbox2/conversation-stream/event-parts/generated-plan': typeof GeneratedPlan;
  }
}
